<div class="tw-flex tw-w-full tw-min-w-0 tw-items-center tw-gap-3">
  <app-account-icon-renderer
    [data]="card().row"
    [useManageAccountStyle]="true"
    [large]="true"
  ></app-account-icon-renderer>

  <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5">
    <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
      <span
        class="card-selected-name tw-min-w-0 tw-truncate tw-text-[15px] tw-font-semibold tw-text-color-text-default"
        [attr.title]="card().name"
        data-testid="account-card-name"
        >{{ card().name }}</span
      >
      <span
        class="tw-shrink-0 tw-whitespace-nowrap tw-rounded-lg tw-bg-color-surface-page tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-medium tw-text-color-text-secondary"
        data-testid="account-card-tag"
        >{{ card().tag }}</span
      >
    </div>
    @if (card().subtitle) {
      <span
        class="tw-truncate tw-text-xs tw-text-color-text-tertiary"
        data-testid="account-card-subtitle"
        >{{ card().subtitle }}</span
      >
    }
  </div>

  <div class="tw-flex tw-shrink-0 tw-items-baseline tw-gap-1">
    @if (simple() && card().status.text) {
      <span
        class="tw-h-1.5 tw-w-1.5 tw-shrink-0 tw-self-center tw-rounded-full"
        [ngClass]="dotClass()"
        [attr.title]="card().status.text"
        data-testid="account-card-status-dot"
        ><span class="tw-sr-only">{{ card().status.text }}</span></span
      >
    }
    <span
      class="tw-font-D-DIN-PRO tw-text-base tw-font-semibold tw-leading-[125%] tw-tracking-[0.01em]"
      [ngClass]="amountClass()"
      [attr.data-testid]="'account-balance-amount-' + card().id"
      >{{ card().balance | macroNumber }}</span
    >
    <span
      class="tw-text-[10px] tw-font-semibold tw-leading-[100%]"
      [ngClass]="unitClass()"
      [attr.data-testid]="'account-balance-currency-' + card().id"
      >{{ card().unit }}</span
    >
  </div>
</div>

@if (!simple()) {
  <div
    class="tw-h-1.5 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-dt-neutral-300"
    data-testid="account-card-meter"
  >
    <div
      class="tw-h-full tw-rounded-full"
      [ngClass]="meterClass()"
      [style.width.%]="card().meter.percent"
    ></div>
  </div>

  <div class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-text-xs">
    <span
      class="tw-min-w-0 tw-truncate tw-text-color-text-tertiary"
      data-testid="account-card-share"
      >{{ card().meter.label }}</span
    >
    @if (card().status.text) {
      <span
        class="tw-ml-auto tw-flex tw-shrink-0 tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-font-semibold"
        [ngClass]="statusTextClass()"
        data-testid="account-card-status"
      >
        @if (card().status.syncing && card().status.icon) {
          <svg class="tw-h-4 tw-w-4" [class.tw-animate-spin-slow]="card().status.spin">
            <use [attr.xlink:href]="'images/sprite.svg#' + card().status.icon"></use>
          </svg>
        } @else {
          <span class="tw-h-1.5 tw-w-1.5 tw-shrink-0 tw-rounded-full" [ngClass]="dotClass()"></span>
        }
        {{ card().status.text }}
      </span>
    }
  </div>
}
